import React, { Component } from "react";
import { connect } from "react-redux";
import { bool, func } from "prop-types";
import { actions as debinActions } from "reducers/debin";
import { Field, Form, withFormik } from "formik";
import { compose } from "redux";
import Button from "pages/_components/Button";
import * as i18n from "util/i18n";
import I18n from "pages/_components/I18n";
import TextField from "pages/_components/fields/TextField";

const FORM_ID = "debin.solicitDebin";

class AddBeneficiary extends Component {
    static propTypes = {
        handleSubmit: func.isRequired,
        isSubmitting: bool.isRequired,
        setOpenSidebarForm: func.isRequired,
    };

    render() {
        const { handleSubmit, isSubmitting, setOpenSidebarForm } = this.props;

        return (
            <div className="container">
                <I18n id="transfer.contactDestination.title" component="h2" />
                <Form
                    className="above-the-fold"
                    onSubmit={(e) => {
                        handleSubmit(e, setOpenSidebarForm);
                        e.stopPropagation();
                    }}>
                    <Field
                        component={TextField}
                        labelnoI18n={`${i18n.get(`${FORM_ID}.creditAccountCbuNumber.label`)}*`}
                        idForm={FORM_ID}
                        name="creditCbu"
                        type="text"
                        hidePlaceholder
                    />
                    <Button type="submit" className="btn-primary" label="global.add" loading={isSubmitting} />
                </Form>
            </div>
        );
    }
}

export default compose(
    connect(),
    withFormik({
        mapPropsToValues: () => ({
            creditCbu: "",
        }),
        handleSubmit: (form, formikBag) => {
            const { setSubmitting, setErrors } = formikBag;
            const { dispatch } = formikBag.props;
            setSubmitting(true);

            if (form.creditCbu === "") {
                setErrors({
                    creditCbu: i18n.get("global.error.required"),
                });
                setSubmitting(false);
            } else {
                dispatch(debinActions.getAccountInfoByCbuCbuCvuAlias(form.creditCbu, formikBag));
            }
        },
    }),
)(AddBeneficiary);
